import { render, staticRenderFns } from "./DistributorDetailsPage.vue?vue&type=template&id=48324f25&scoped=true&"
import script from "./DistributorDetailsPage.vue?vue&type=script&lang=js&"
export * from "./DistributorDetailsPage.vue?vue&type=script&lang=js&"
import style0 from "./DistributorDetailsPage.vue?vue&type=style&index=0&id=48324f25&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48324f25",
  null
  
)

export default component.exports